import { NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { FeaturesComponent } from './features/features.component';

import { LogOutComponent } from './log-out/log-out.component';
import { CompanyRecordingComponent } from './master-data/company-recording/company-recording.component';
import { InventorRecordingComponent} from './master-data/inventor-recording/inventor-recording.component'
import { MasterDataComponent } from './master-data/master-data.component';

import { NavBarComponent } from './patent-detail/nav-bar/nav-bar.component';
import { RecordInventionComponent } from './patent-detail/record-invention/record-invention.component';
import {PatentRecordComponent} from './patent-detail/patent-record/patent-record.component';
import {CountryRecordComponent} from './patent-detail/patent-record/country-record/country-record.component'
import {MailCenterComponent} from './mail-center/mail-center.component'
//import { PatentDetailComponent } from './patent-detail/patent-detail.component';
import { PatentListComponent } from './patent-list/patent-list.component';

import { WELLCOMEComponent } from './wellcome/wellcome.component';
import { CriticalComponent } from './patent-list/critical/critical.component';
import { BbfComponent } from './bbf/bbf.component';
import { ApplicationStateService } from './shared/Size/application-state.service';
import { AttorneyRecordingComponent } from './master-data/attorney-recording/attorney-recording.component';
import { OtherJobsComponent } from './master-data/other-jobs/other-jobs.component';
import { EditCountryComponent } from './patent-detail/patent-record/country-record/edit-country/edit-country.component';
import { SearchComboComponent } from './patent-list/search-combo/search-combo.component';
import { RdprojectRecordingComponent } from './master-data/rdproject-recording/rdproject-recording.component';
const routes: Routes = [
{path:"" ,component:WELLCOMEComponent},
{path:"auth" ,component:AuthComponent},
//{path:"user/:id" ,component:FeaturesComponent},
{path:"saveInvention" ,component:FeaturesComponent},
{path:"patentList" ,component:SearchComboComponent},
{path:"patentList/:id" ,component:NavBarComponent},
{path:"patentList/:id/recordInvention" ,component:RecordInventionComponent},
{path:"patentList/:id/recordPatent" ,component:PatentRecordComponent},
{path:"patentList/:id/countryRecord/:country" ,component:CountryRecordComponent},
{path:"patentList/:id/countryRecord/:country/edit" ,component:EditCountryComponent},
{path:"patentList/:id/mailCenter" ,component:MailCenterComponent},

{path:"logout" ,component:LogOutComponent},
{path:"masterData" ,component:MasterDataComponent},
{path:"masterData/Inventors" ,component:InventorRecordingComponent},
{path:"masterData/Companies" ,component:CompanyRecordingComponent},
{path:"masterData/Attornies" ,component:AttorneyRecordingComponent},
//RDProjects
{path:"masterData/RDProjects" ,component:RdprojectRecordingComponent},
{path:"otherjobs" ,component:OtherJobsComponent},
{path:"critical" ,component:CriticalComponent},
{path:"searchCombo" ,component:SearchComboComponent},
{path:"bbf" ,component:BbfComponent},

];
//recordPatent
@NgModule({
  imports: [RouterModule.forRoot(routes,{onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
   constructor(private router: Router,
  private applicationStateService: ApplicationStateService) {
    console.log(this.applicationStateService);
    this.applicationStateService;
    console.log(this.applicationStateService);
  if (this.applicationStateService.getIsMobileResolution()) {
    this.router.resetConfig(routes);
  }
  else {this.router.resetConfig(routes);}
}}
